if (!customElements.get('product-options')) {
class ProductOptionPicker extends HTMLElement{
    constructor(){
        super();
        this.product = {};
        this.chosenOptionsObject = {};
        this.selectOptionsListObject = [];
    }

    connectedCallback() {
        if (this.dataset.optionsInitialized === 'true') {
            return;
        }
        this.dataset.optionsInitialized = 'true';

        this.form = this.closest('form') || this.parentElement;
        this.refreshElements();
        this.productDropdowns = this.querySelectorAll('.product-option-picker__dropdown');

        if (this.select) {
            this.selectOptionsListObject = [];
            this.prepareOptions(this.select);
        }

        this.getProduct().then(res => this.product = res);

        for (let dropdown of this.productDropdowns) {
            dropdown.addEventListener('click', (event) => {
                this.dropdown(dropdown, event);
            });

            document.addEventListener('click', (event) => {
                if (event.target !== dropdown && !dropdown.contains(event.target)) {
                    this.closeDropdown(dropdown);
                }
            });
        }

        for (let list of this.productOptions) {
            this.chosenOptionsObject[list.dataset.optionName] = list.dataset.optionValue;
        }

        if (this.select) {
            this.prepareSelectionListObject();
            this.checkOptionsAvailability();
            this.ensureChosenOptionsAvailable();
            this.markNoStockTooltips();
        }

        for (let productOption of this.productOptionsList) {
            productOption.addEventListener('focus', () => {
                productOption.addEventListener('keyup', (event) => {
                    if (event.key === 'Enter') {
                        productOption.click();
                    }
                });
            });
        }
    }

    refreshElements() {
        this.productOptions = this.querySelectorAll('ul');
        this.productOptionsList = this.querySelectorAll('li');
        this.select = this.form?.querySelector('.product-variants-selector-select, select[name="id"]');
    }

    handleOptionClick(option) {
        if (!option || option.classList.contains('disabled') || option.classList.contains('unavailable') || option.classList.contains('chosen')) {
            return;
        }

        this.refreshElements();
        this.selectionPicker(option);
        this.onClick(option);
        this.checkOptionsAvailabilityOnClick(option);
        this.ensureChosenOptionsAvailable();
        this.markNoStockTooltips();
    }

    getProduct = async () => {
        var handle = this.dataset.productHandle;

        return await fetch(`${window.Shopify.routes.root}products/${handle}.js`)
        .then((response) => {
            if (!response.ok) {
                var error = new Error(response.status);
                throw error;
            }

            return response.json();
        })
        .catch((error) => {
            throw error;
        });
    }


    prepareOptions(select){
        if (!select) {
            return;
        }

        var availableOptions = [];
        var selectOptionsList = [];

        for (let list of this.productOptions) {
            availableOptions.push(list.dataset.optionName);
        }


        for (let selectOption of select) {
            var matchFound = false;
            for (let productOption of this.productOptionsList) {
              if (selectOption.innerText.trim() == productOption.dataset.optionValue) {
                matchFound = true;
              }
            }

            if (matchFound) {
              selectOptionsList.push([selectOption.text.trim()]);
            }
            else {
              var selectOptionArray = selectOption.text.split(' / ');

              this.productOptions.forEach(productOptions => {
                productOptions.querySelectorAll('li').forEach(productOption => {
                  var productOptionValue = productOption.dataset.optionValue;
                  if (productOptionValue.includes(' / ')) {
                    if (selectOption.text.includes(productOption.dataset.optionValue)) {
                      var newValue = productOption.dataset.optionValue.split(' / ');
                      var newSelectOption = selectOption.text.replace(productOption.dataset.optionValue, newValue.join(' $/ '));
                      selectOptionArray = newSelectOption.split(' / ');
                    }
                  }
                });
              });

              selectOptionsList.push(selectOptionArray.map((string) => {
                  var newString = string.replace(/\$\//gi, '/');
                  newString = newString.trim();
                  return newString;
              }));
            }
        }

        for (let optionValueArray of selectOptionsList) {
            var availableOptionsObject = {};

            availableOptions.map(function(optionName, i) {
                availableOptionsObject[optionName] = optionValueArray[i];
            });

            this.selectOptionsListObject.push(availableOptionsObject);
        }
    }

    onClick(option){
        this.productOptions = option.closest('product-options').querySelectorAll('ul');

        this.chosenOptionsObject = {};
        this.selectOptionsListObject = [];
        this.productOptions.forEach(list => {
            for (let list_item of list.children) {
                if (list_item.classList.contains('chosen')) {
                    var chosenOptionValue = list_item.dataset.optionValue;
                    var chosenOptionName = list.dataset.optionName;

                    this.chosenOptionsObject[chosenOptionName] = chosenOptionValue;
                }
            }
        });

        this.select = option.closest('.product')?.querySelector('.product-variants-selector-select, select[name="id"]');
        if (!this.select) {
            return;
        }

        this.prepareOptions(this.select);
        this.prepareSelectionListObject();

        var inQuickview = !!option.closest('.popup-modal-quickview, .quickview-product');

        this.selectOptionsListObject.forEach((variantOption) => {
            const newOption = Object.assign({}, variantOption);
            delete newOption.available;
            delete newOption.stock;
            delete newOption.management;
            delete newOption.index;
            delete newOption.policy;

            if (JSON.stringify(newOption) === JSON.stringify(this.chosenOptionsObject)) {
                if (typeof variantOption.index != 'undefined') {
                    this.select.selectedIndex = variantOption.index;
                    this.select.dispatchEvent(new Event('change', { bubbles: true }));

                    var variantId = this.select[variantOption.index].getAttribute('value');

                    if (!Shopify.designMode && !inQuickview) {
                        var newUrl = new URL(window.location.href);

                        if (newUrl.searchParams.get('variant') !== null) {
                            newUrl.searchParams.set('variant', variantId);
                        }
                        else {
                            newUrl.searchParams.append('variant', variantId);
                        }

                        history.pushState({}, null, newUrl);
                    }
                }
                else {
                    this.select.selectedIndex = 0;
                    this.select.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
        });
    }

    selectionPicker(option){
        var currentDropdown = option.parentElement;
        var currentDropdownListItems = currentDropdown.querySelectorAll('li');
        var chosenElements = currentDropdown.parentElement.parentElement.querySelectorAll('.product-option-picker-chosen > span, .product-option-picker-label > .product-option-picker-label--chosen');
        var chosenSwatchElement = currentDropdown.parentElement.parentElement.querySelector('.product-option-picker-chosen > .product-option-swatch');
        var chosenOptionSwatch = option.querySelector('.product-option-swatch');

        for (let item of currentDropdownListItems) {
            item.classList.remove('chosen');
        }
        option.classList.add('chosen');

        for (let chosen of chosenElements) {
            chosen.innerText = option.querySelector('.product-option-label__value')?.textContent.trim() || option.textContent.trim();
        }

        if (chosenOptionSwatch) {
            var optionProductSwatchStyles = getComputedStyle(chosenOptionSwatch);
            var optionSwatchColor = optionProductSwatchStyles.getPropertyValue('--product-swatch-value');
            if (optionSwatchColor.length == 0) {
                optionSwatchColor = option.dataset.optionValue;
            }
            if (chosenSwatchElement) {
                chosenSwatchElement.innerHTML = chosenOptionSwatch.innerHTML;
                chosenSwatchElement.style.setProperty('--product-swatch-value', optionSwatchColor);
            }
        }
    }


    prepareSelectionListObject(){
        if (!this.select) {
            return;
        }

        var newSelectOptions = this.selectOptionsListObject.map(obj => Object.assign({}, obj));

        this.select.querySelectorAll('option').forEach((option, index) => {
            if (newSelectOptions[index]) {
                newSelectOptions[index].stock = parseInt(option.dataset.inventoryQuantity);
                newSelectOptions[index].management = option.dataset.inventoryManagement;
                newSelectOptions[index].policy = option.dataset.inventoryPolicy;
            }
        });

        var customSelectOptions = [];
        Object.entries(this.chosenOptionsObject).forEach(chosenOption => {
            var eachOptions = [];
            this.productOptions.forEach((productOption) => {
                if (chosenOption[0] == productOption.dataset.optionName) {
                    for (let option of productOption.children) {
                        eachOptions.push({ [productOption.dataset.optionName]: option.dataset.optionValue});
                    }
                }
            });
            customSelectOptions.push(eachOptions);
        });

        const generateCombinations = (data) => {
            const result = [];
            const resultTrimmed = [];
            function helper(temp, index) {
              if (temp.length === data.length) {
                result.push(temp);
                return;
              }
              for (let i = 0; i < data[index].length; i++) {
                helper([...temp, data[index][i]], index + 1);
              }
            }
            helper([], 0);

            result.forEach(data => {
                const obj = data.reduce((result, item) => {
                    return { ...result, ...item };
                  }, {});
                  resultTrimmed.push(obj);
              });
            return resultTrimmed;
        };

        let newcustomSelectOptions = generateCombinations([...customSelectOptions]);

        if (!newcustomSelectOptions.length) {
            return;
        }

        let availableKeys = Object.keys(newcustomSelectOptions[0]);

        const finalSelectOptions = newcustomSelectOptions.map((selectOption) => {
            let newSelectOption = Object.assign({}, selectOption);
            newSelectOptions.forEach((option, index) => {
                if (availableKeys.every(key => {
                    return option[key] == selectOption[key];
                })) {
                    selectOption.available = true;
                    newSelectOption = {...selectOption, ...option, index};
                }
                else {
                    if (!selectOption.hasOwnProperty('available')) {
                        selectOption.available = false;
                        selectOption.stock = 0;
                        selectOption.management = 'shopify';
                        selectOption.policy = 'deny';
                        newSelectOption = selectOption;
                    }
                }
            });

            return newSelectOption;
        });

        this.selectOptionsListObject = finalSelectOptions;
    }

    checkOptionsAvailability(){
        for (let productOption of this.productOptionsList) {
            productOption.classList.remove('disabled');
            productOption.classList.remove('unavailable');
        }

        var newSelectOptions = this.selectOptionsListObject.map(obj => Object.assign({}, obj));

        var productOptionsArray = {};

        this.productOptions.forEach(productOption => {
            productOptionsArray[productOption.dataset.optionName] = Array.from(productOption.children).map(option => option.dataset.optionValue);
        });

        if (Object.keys(productOptionsArray).length == 1) {
            newSelectOptions.forEach(option => {
                if ((option.stock == 0 && option.management != '' && option.policy != 'continue') || !option.available) {
                    this.productOptions.forEach(productOption => {
                        for (let optionValue of productOption.children) {
                            if (option[productOption.dataset.optionName] == optionValue.dataset.optionValue) {
                                optionValue.classList.add('disabled');
                            }
                        }
                    });
                }
            });
        }

        this.productOptions.forEach(productOption => {
            let filterdSelectOptions = newSelectOptions.filter(option => {
                return option[productOption.dataset.optionName] != this.chosenOptionsObject[productOption.dataset.optionName];
            });

            for (let optionValue of productOption.children) {
                if (optionValue.dataset.optionValue !== this.chosenOptionsObject[productOption.dataset.optionName]) {
                    if (filterdSelectOptions.every(option => {
                        return (option.stock == 0 && option.management != '' && option.policy != 'continue') || !option.available;
                    })) {
                        optionValue.classList.add('disabled');
                    }
                    else {
                        var chosenOptionsObject = Object.assign({}, this.chosenOptionsObject);
                        delete chosenOptionsObject[productOption.dataset.optionName];

                        filterdSelectOptions.forEach((option) => {
                            var chosenSelectOptions = Object.entries(chosenOptionsObject).map(chosenOption => {
                                return option[chosenOption[0]] == chosenOption[1];
                            });

                            if (chosenSelectOptions.every(option => option)) {
                                if ((option.stock == 0 && option.management != '' && option.policy != 'continue') || !option.available) {
                                    if (option[productOption.dataset.optionName] == optionValue.dataset.optionValue) {
                                        optionValue.classList.add('disabled');
                                    }
                                }
                            }
                        });

                        filterdSelectOptions.forEach((option) => {
                            if (option.available && (option.stock != 0 || option.management == '' || option.policy == 'continue')) {
                                if (option[productOption.dataset.optionName] == optionValue.dataset.optionValue) {
                                    if (optionValue.classList.contains('disabled')) {
                                        optionValue.classList.add('unavailable');
                                        optionValue.classList.remove('disabled');
                                    }
                                }
                            }
                        });
                    }
                }
            }
        });
    }

    checkOptionsAvailabilityOnClick(option){
        var productOptionsList = option.closest('product-options').querySelectorAll('li');

        for (let productOption of productOptionsList) {
            productOption.classList.remove('disabled');
            productOption.classList.remove('unavailable');
        }

        var newSelectOptions = this.selectOptionsListObject.map(obj => Object.assign({}, obj));

        this.productOptions.forEach(productOption => {
            let filterdSelectOptions = newSelectOptions;

            for (let optionValue of productOption.children) {
                if (filterdSelectOptions.every(item => { return (item.stock == 0 && item.management != '' && item.policy != 'continue') || !item.available; })) {
                    optionValue.classList.add('disabled');
                }
                else {
                    var chosenOptionsObject = Object.assign({}, this.chosenOptionsObject);
                    delete chosenOptionsObject[productOption.dataset.optionName];

                    filterdSelectOptions.forEach((item) => {
                        var chosenSelectOptions = Object.entries(chosenOptionsObject).map(chosenOption => {
                            return item[chosenOption[0]] == chosenOption[1];
                        });

                        if (chosenSelectOptions.every(match => match)) {
                            if ((item.stock == 0 && item.management != '' && item.policy != 'continue') || !item.available) {
                                if (item[productOption.dataset.optionName] == optionValue.dataset.optionValue) {
                                    optionValue.classList.add('disabled');
                                }
                            }
                        }
                    });

                    filterdSelectOptions.forEach((item) => {
                        if (item.available && (item.stock != 0 || item.management == '' || item.policy == 'continue')) {
                            if (item[productOption.dataset.optionName] == optionValue.dataset.optionValue) {
                                if (optionValue.classList.contains('disabled')) {
                                    optionValue.classList.add('unavailable');
                                    optionValue.classList.remove('disabled');
                                }
                            }
                        }
                    });
                }
            }
        });
    }


    isPurchasable(option) {
        return option.available && (option.stock != 0 || option.management == '' || option.policy == 'continue');
    }

    ensureChosenOptionsAvailable() {
        if (!this.select || !this.productOptions?.length) {
            return;
        }

        let guard = 0;
        while (guard++ < 5) {
            this.refreshElements();
            let fixed = false;

            for (const productOption of this.productOptions) {
                const optionName = productOption.dataset.optionName;
                const chosenVal = this.chosenOptionsObject[optionName];
                const chosenLi = [...productOption.children].find(li => li.dataset.optionValue === chosenVal);

                if (!chosenLi || (!chosenLi.classList.contains('disabled') && !chosenLi.classList.contains('unavailable'))) {
                    continue;
                }

                const next = [...productOption.children].find(li =>
                    !li.classList.contains('disabled') && !li.classList.contains('unavailable')
                );

                if (!next) {
                    continue;
                }

                this.selectionPicker(next);
                this.chosenOptionsObject[optionName] = next.dataset.optionValue;
                productOption.dataset.optionValue = next.dataset.optionValue;
                this.onClick(next);
                this.checkOptionsAvailabilityOnClick(next);
                this.markNoStockTooltips();
                fixed = true;
                break;
            }

            if (!fixed) {
                break;
            }
        }
    }


    markNoStockTooltips() {
        this.refreshElements();
        for (const li of this.productOptionsList) {
            let tip = li.querySelector('.product-option-nostock-tooltip');
            if (li.classList.contains('disabled') || li.classList.contains('unavailable')) {
                li.setAttribute('aria-disabled', 'true');
                li.setAttribute('title', 'No Stock Available');
                if (!tip) {
                    tip = document.createElement('span');
                    tip.className = 'product-option-nostock-tooltip';
                    tip.textContent = 'No Stock Available';
                    tip.setAttribute('aria-hidden', 'true');
                    li.appendChild(tip);
                }
            } else {
                li.removeAttribute('aria-disabled');
                if (li.getAttribute('title') === 'No Stock Available') {
                    li.removeAttribute('title');
                }
                if (tip) tip.remove();
            }
        }
    }

    dropdown(dropdown, event){
        if (dropdown.classList.contains('active')) {
            this.closeDropdown(dropdown);
            dropdown.blur();
        }
        else {
            if (!dropdown.matches(':focus-within:not(:focus)')) {
                this.openDropdown(dropdown);
            }
        }
    }

    openDropdown(dropdown){
        dropdown.classList.add('active');
    }
    closeDropdown(dropdown){
        dropdown.classList.remove('active');
    }

}

document.body.addEventListener('click', (event) => {
    var option = event.target.closest('.product-option-picker__list-item');
    if (!option) {
        return;
    }

    var picker = option.closest('product-options');
    if (!picker) {
        return;
    }

    picker.handleOptionClick(option);
});

customElements.define('product-options', ProductOptionPicker);
}
